import HOST_API from 'constants/HOST_API';
import useFetch from './useFetch';


import React from 'react';
import Recoil from 'recoil';
import CryptoJS from 'crypto-js';

export default function useDoctorGuideDelete(props) {
  const onRequest = useFetch(HOST_API, 'V100/doctor/dr-guide/delete');

  const requestDoctorGuideDelete = React.useCallback((parameters, callback) => {
    const {
      dr_id,
      patient_no,
      guide_time,
    } = parameters;

    if(!dr_id) return;
    if(!patient_no) return;

    const onReceive = (res) => {
      if (+res.res_code === 200) {
        callback && callback(true, res.data, parameters);
      } else {
        callback && callback(false, { message: res?.res_msg });
      }
    };
    const onCatch = (err) => {
      callback && callback(false, { messgae: '서버에 연결할 수 없습니다.' }, parameters);
    };
    const onExpire = (abort) => {
      abort('Timeout');
      callback && callback(false, { message: '서버가 응답하지 않습니다.' }, parameters);
      return true;
    };

    onRequest({
      parameters: {
        dr_id,
        patient_no,
        guide_time,
      },
      timeout: 6000,
      events: {
        onReceive,
        onExpire,
        onCatch,
      }
    });
  }, [onRequest]);

  const onDoctorGuideDelete = React.useCallback((parameters, callback) => () => {
    requestDoctorGuideDelete(parameters, callback);
  }, [requestDoctorGuideDelete]);

  return {
    requestDoctorGuideDelete,
    onDoctorGuideDelete,
  };
}
